<template lang="pug">
form.columns.align-center.my-2(@submit.prevent="onFilter")
  .pb-1.column.col-auto(v-if="isEnabledFilter('numero_eq')")
    small {{ filters.numero_eq }}
    int.form-input.input-sm(v-model="q.numero_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('ano_eq')")
    small {{ filters.ano_eq }}
    year.form-input.input-sm(v-model="q.ano_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_id_eq')")
    small {{ filters.cadastro_id_eq }}
    cadastro-picker(v-model="q.cadastro_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('created_at_gteq')")
    small {{ filters.created_at_gteq }}
    datepicker(v-model="q.created_at_gteq", input-class="form-input input-sm")
  .pb-1.column.col-auto(v-if="isEnabledFilter('created_at_lteq')")
    small {{ filters.created_at_lteq }}
    datepicker(v-model="q.created_at_lteq", input-class="form-input input-sm")
  .pb-1.column.col-auto(v-if="isEnabledFilter('concluido_em_gteq')")
    small {{ filters.concluido_em_gteq }}
    datepicker(
      v-model="q.concluido_em_gteq",
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('concluido_em_lteq')")
    small {{ filters.concluido_em_lteq }}
    datepicker(
      v-model="q.concluido_em_lteq",
      full-day,
      input-class="form-input input-sm"
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('contribuinte_cpf_cnpj_eq')")
    small {{ filters.contribuinte_cpf_cnpj_eq }}
    input-cpf-cnpj.form-input.input-sm(v-model="q.contribuinte_cpf_cnpj_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_zona_eq')")
    small {{ filters.cadastro_zona_eq }}
    input.form-input.input-sm(v-model="q.cadastro_zona_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_quadra_eq')")
    small {{ filters.cadastro_quadra_eq }}
    input.form-input.input-sm(v-model="q.cadastro_quadra_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_lote_eq')")
    small {{ filters.cadastro_lote_eq }}
    input.form-input.input-sm(v-model="q.cadastro_lote_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('protocolo_tipo_eq')")
    small {{ filters.protocolo_tipo_eq }}
    select-protocolo-tipo.select-sm(v-model="q.protocolo_tipo_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('protocolo_numero_eq')")
    small {{ filters.protocolo_numero_eq }}
    input.form-input.input-sm(v-model="q.protocolo_numero_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('protocolo_ano_eq')")
    small {{ filters.protocolo_ano_eq }}
    input.form-input.input-sm(v-model="q.protocolo_ano_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('assunto_id_eq')")
    small {{ filters.assunto_id_eq }}
    assunto-picker(v-model="q.assunto_id_eq", sm)
  .pb-1.column.col-auto.tooltip.tooltip-bottom(
    v-if="isEnabledFilter('assunto_compartilhado_eq')",
    data-tooltip="Com outros departamentos"
  )
    small {{ filters.assunto_compartilhado_eq }}
    select.form-select.select-sm(v-model="q.assunto_compartilhado_eq", sm)
      option(:value="undefined") Todos
      option(:value="true") Sim
      option(:value="false") Não
  .pb-1.column.col-auto(v-if="isEnabledFilter('usuario_responsavel_id_eq')")
    small {{ filters.usuario_responsavel_id_eq }}
    fiscal-picker(v-model="q.usuario_responsavel_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('usuario_id_eq')")
    small {{ filters.usuario_id_eq }}
    fiscal-picker(v-model="q.usuario_id_eq", sm)
  .pb-1.column.col-auto(
    v-if="isEnabledFilter('usuario_responsavel.usuario_grupo_id_in')"
  )
    small {{ filters["usuario_responsavel.usuario_grupo_id_in"] }}
    usuario-grupos-picker(
      v-model="q['usuario_responsavel.usuario_grupo_id_in']",
      sm
    )
  .pb-1.column.col-auto(v-if="isEnabledFilter('comentario_situacao_id_eq')")
    small {{ filters.comentario_situacao_id_eq }}
    comentario-situacao-picker(v-model="q.comentario_situacao_id_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('situacao_eq')")
    small {{ filters.situacao_eq }}
    select-ordem-servico-situacao.select-sm(v-model="q.situacao_eq", sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('cadastro_id_null')")
    small &nbsp;
    label.form-checkbox
      input(
        type="checkbox",
        v-model="q.cadastro_id_null",
        @change="onToggleCadastroIdNull"
      )
      i.form-icon
      | {{ filters.cadastro_id_null }}
  .pb-1.column.col-auto
    small Ordenar por
    order-by(:fields="orderByFields", :query="q", sm)
  .column.col-auto
    .label-padding-top.d-flex
      enabled-filters(
        localStorageKey="osm_servicos_enabled_filters",
        :defaultEnabledFilters="defaultEnabledFilters",
        :enabledFilters="enabledFilters",
        :filters="filters",
        :query="q",
        :setEnabledFilters="setEnabledFilters"
      )
      a.btn.btn-link.btn-sm.no-print.tooltip.tooltip-bottom(
        data-tooltip="Imprimir",
        onclick="window.print()"
      )
        i.fa.fa-lg.fa-print
      button.btn.btn-sm.btn-link.tooltip.tooltip-bottom(
        data-tooltip="Filtrar",
        :disabled="$v.q.$invalid"
      )
        i.fa.fa-search.fa-lg
      slot(name="additionalButtons")
</template>

<script>
import filterMixin, { defaultStoreImports } from "@/mixins/filter"

export default {
  data() {
    return {
      filters: {
        numero_eq: this.$options.filters.tModel("ordem_servico.numero"),
        ano_eq: this.$options.filters.tModel("ordem_servico.ano"),
        cadastro_id_eq: this.$options.filters.tModel("cadastro"),
        created_at_gteq: "Data início",
        created_at_lteq: "Data fim",
        cadastro_id_null: "Apenas avulsas",
        concluido_em_gteq: "Data conclusão início",
        concluido_em_lteq: "Data conclusão fim",
        contribuinte_cpf_cnpj_eq: this.$options.filters.tModel(
          "contribuinte.cpf_cnpj",
        ),
        cadastro_zona_eq: this.$options.filters.tModel("cadastro.zona"),
        cadastro_quadra_eq: this.$options.filters.tModel("cadastro.quadra"),
        cadastro_lote_eq: this.$options.filters.tModel("cadastro.lote"),
        protocolo_tipo_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_tipo",
        ),
        protocolo_numero_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_numero",
        ),
        protocolo_ano_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_ano",
        ),
        assunto_id_eq: this.$options.filters.tModel("ordem_servico.assunto"),
        assunto_compartilhado_eq: "Assunto compartilhado",
        usuario_responsavel_id_eq: this.$options.filters.tModel(
          "ordem_servico.usuario_responsavel",
        ),
        usuario_id_eq: this.$options.filters.tModel("ordem_servico.usuario"),
        "usuario_responsavel.usuario_grupo_id_in": "Grupos de usuário",
        comentario_situacao_id_eq: this.$options.filters.tModel(
          "ordem_servico.comentario_situacao",
        ),
        situacao_eq: this.$options.filters.tModel("ordem_servico.situacao"),
      },
      defaultEnabledFilters: ["numero_eq", "ano_eq"],
      orderByFields: {
        numero: this.$options.filters.tModel("ordem_servico.numero"),
        ano: this.$options.filters.tModel("ordem_servico.ano"),
        cadastro_numero: this.$options.filters.tModel("cadastro"),
        created_at: this.$options.filters.tModel("ordem_servico.created_at"),
        concluido_em: this.$options.filters.tModel(
          "ordem_servico.concluido_em",
        ),
        cadastro_zona: this.$options.filters.tModel("cadastro.zona"),
        cadastro_quadra: this.$options.filters.tModel("cadastro.quadra"),
        cadastro_lote: this.$options.filters.tModel("cadastro.lote"),
        protocolo_numero_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_numero",
        ),
        protocolo_ano_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_ano",
        ),
        assunto_descricao: this.$options.filters.tModel(
          "ordem_servico.assunto",
        ),
        "usuario_responsavel.nome": this.$options.filters.tModel(
          "ordem_servico.usuario_responsavel",
        ),
        "usuario_responsavel.usuario_grupo.nome": this.$options.filters.tModel(
          "usuario.usuario_grupo",
        ),
        usuario_nome: this.$options.filters.tModel("ordem_servico.usuario"),
      },
    }
  },
  methods: {
    onToggleCadastroIdNull() {
      if (!this.q.cadastro_id_null) this.$delete(this.q, "cadastro_id_null")
    },
  },
  validations: {
    q: {},
  },
  vuex: { servicos: defaultStoreImports },
  mixins: [filterMixin],
}
</script>
